<div class="modal-header">
  <h4 class="modal-title">Team keuzemenu</h4>
  <button type="button" class="btn-close" nofocus (click)="cancel()"></button>
</div>
<div class="modal-body">
  <div class="mb-3">
    <div class="d-flex justify-content-between">
      <label class="input__label mb-0">Kies een team uit de lijst</label>
    </div>
    <div class="input-group">
      <select class="form-select" [(ngModel)]="selectedId" (ngModelChange)="selectionError = ''">
        <option selected [ngValue]="null">{{ defaultValue }}</option>
        @for (t of teams; track t) {
          <option [ngValue]="t.globalId">{{ t.teamnaam }}</option>
        }
      </select>
      <button class="btn btn-primary" type="button" id="button-addon2" (click)="selectedId = null"><fa-icon [icon]="['fas', 'x']" /></button>
    </div>
    <small class="form-text text-muted"></small>
    @if (selectionError) {
      <div class="text-danger mt-2" role="alert">{{ selectionError }}</div>
    }
  </div>

  <ngb-alert [dismissible]="false" type="info" title="Geen team"
    ><fa-icon [icon]="['fas', 'info-circle']"></fa-icon> Is de keuzelijst leeg en kun je geen team selecteren? Is je naam of e-mailadres gewijzigd?
    Afmelden en opnieuw aanmelden met Google kan dan helpen. Blijft de keuzelijst leeg? Neem dan contact op met support via
    <a
      href="mailto:support@intellicare.nl?subject=Lege keuzelijst Buurtzorg&body=%0A%0A%0AVan {{ fbUser.email }} ({{ user.email }})%0AVia Buurtzorg"
      target="_blank"
      >support&#64;intellicare.nl</a
    >.
    <br />
    <small class="form-text text-muted"> Ingelogd als: {{ fbUser.email }} ({{ user.email }})</small>
  </ngb-alert>
</div>
<div class="modal-footer">
  <ng-container>
    <button type="button" class="btn btn-secondary" (click)="cancel()">Annuleren</button>
  </ng-container>
  <ng-container>
    <button type="button" class="btn btn-success" (click)="save()">Opslaan</button>
  </ng-container>
</div>
